// extracted by mini-css-extract-plugin
module.exports = {"innerContainer":"RolesCard_innerContainer__20zzv","rolesInfo":"RolesCard_rolesInfo__c2MQG","label":"RolesCard_label__1VG13","values":"RolesCard_values__3mUbv"};